import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from "typeorm";
import { EnquiriesEntity } from "../../enquiries/entites/enquiries";

@Entity("frieght_forward_expeneses")
export class FreightForwardExpensesEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"freight_forward_expense_id"
    }) 
    freightForwardExpenseId: number;
    @Column('int',{
        name:'variant_id',
        nullable:false
    })
    variantId: number

   @Column('int',{
    name:'ocean_freight',
    nullable:false
   })
   oceanFreight: number

   @Column('int',{
    name:'anti_dumping_duty',
    nullable:false
   })
   antiDumpingDuty: number

   @Column('int',{
    name:'local_freight_charges',
    nullable:false
   })
   localFreightCharges: number

   @Column('int',{
    name:'EIA_charges',
    nullable:false
   })
   EIACharges: number

   @Column('int',{
    name:'marine_insurance',
    nullable:false
   })
   marineInsurance: number

   @Column('int',{
    name:'agri_marketing_cess',
    nullable:false
   })
   agriMarketingCess: number

   @Column('int',{
    name:'clearing_nd_forwarding_charges',
    nullable:false
   })
   clearingAndForwardingCharges: number

   @Column('int',{
    name:'survey_expenses',
    nullable:false
   })
   surveyExpenses: number

   @Column('int',{
    name:'other_expenses',
    nullable:false
   })
   otherExpenses: number

   @ManyToOne(() => EnquiriesEntity,enquiries =>enquiries.freightExp )
    @JoinColumn({name:'enquiry_id'})
    enquiryEntity:EnquiriesEntity

}